<template>
    <v-card>
        <v-form
            ref="smsCustomerForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-textarea
                                :rules="[requiredRule,lengthRule(160)]"
                                counter
                                label="Sms Message"
                                v-model="message"
                            ></v-textarea>
                        </v-col>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSending"
                            :loading="isSending"
                            @click="sendSms"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Send Sms</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
export default {
    props: {
        customerId: {
            type: Number,
            default: null
        },
        companyId: {
            type: Number,
            default: null
        },
        allIndividualCustomers: {
            type: Boolean,
            default: false
        }
    },
    components: {
        //
    },
    data() {
        return {
            message: "",
            isValid: null,
            isLoading: null,
            isSending: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.message = "";
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.message = this.message.trim();
            return this.$refs.smsCustomerForm.validate();
        },
        //sendSms      ------------------------------------------------------------
        sendSms() {
            if (this.validateForm()) {
                var isConfirmed = confirm(
                    "Are you sure you want to send the sms message(s)?"
                );
                if (isConfirmed) {
                    this.isLoading = true;
                    this.isSending = true;

                    const parameters = {
                        message: this.message
                    };
                    if (this.customerId > 0)
                        parameters.customerId = this.customerId;

                    if (this.companyId > 0)
                        parameters.companyId = this.companyId;

                    if (this.allIndividualCustomers == true)
                        parameters.allIndividualCustomers = this.allIndividualCustomers;

                    this.$store
                        .dispatch("customers/sendcustomersms", parameters)
                        .then(
                            () => {                                
                                this.notify("Message(s) sent.", "success");
                            },
                            error => this.notify(error.response.data, "error")
                        )
                        .finally(this.sendSmsDone);
                }
            }
        },

        sendSmsDone() {
            this.isLoading = false;
            this.isSending = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>